import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18","key":"svg-0"}],["path",{"d":"M15 9h-.01","key":"svg-1"}],["path",{"d":"M20 15h-4","key":"svg-2"}]]

const IconMoodLookRight = createReactComponent('outline', 'mood-look-right', 'MoodLookRight', __iconNode);

export default IconMoodLookRight;